(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    if (window.fgfPackGalleryReady) return;

    window.fgfPackGalleryReady = true;
    const pendingSelections = new Map();

    const normalizeText = (value) =>
      String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[’']/g, '')
        .replace(/[–—-]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

    const selectionDetails = (optionName, value) => {
      const colorMatch = optionName.match(/^Couleur\s+(.+)$/i);
      if (colorMatch) {
        const productName = colorMatch[1].trim();
        return {
          exact: `${productName} – ${value}`,
          generic: `${productName} Fungoofun`,
        };
      }

      const charmyMatch = value.match(/^CHARMY\s+(\d+)$/i);
      if (charmyMatch) {
        return {
          exact: `CHARMY modèle ${charmyMatch[1]}`,
          generic: 'CHARMY Fungoofun',
        };
      }

      const accessoryMatch = value.match(/^(PUNCHY Mini|MOONY)\s+(.+)$/i);
      if (accessoryMatch) {
        return {
          exact: `${accessoryMatch[1]} – ${accessoryMatch[2]}`,
          generic: `${accessoryMatch[1]} Fungoofun`,
        };
      }

      return null;
    };

    const activateAccessoryMedia = (productInfo, details) => {
      if (!productInfo || !details) return;

      const gallery = productInfo.querySelector('media-gallery');
      if (!gallery) return;

      const mediaItems = Array.from(gallery.querySelectorAll('li[data-media-id]'));
      const exact = normalizeText(details.exact);
      const generic = normalizeText(details.generic);
      const item =
        mediaItems.find((mediaItem) => normalizeText(mediaItem.querySelector('img[alt]')?.alt) === exact) ||
        mediaItems.find((mediaItem) => normalizeText(mediaItem.querySelector('img[alt]')?.alt) === generic);

      if (item?.dataset.mediaId) gallery.setActiveMedia?.(item.dataset.mediaId, true);
    };

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      const picker = target.closest('variant-selects[data-product-handle^="pack-"]');
      const productInfo = picker?.closest('product-info');
      if (!picker || !productInfo) return;

      const optionGroups = Array.from(picker.querySelectorAll(':scope > .product-form__input'));
      const optionGroup = target.closest('.product-form__input');
      const optionIndex = optionGroups.indexOf(optionGroup);
      const rawName = target.getAttribute('name') || '';
      const optionName =
        target.getAttribute('data-option-name') ||
        rawName.match(/^options\[(.+)\]$/)?.[1] ||
        rawName.replace(/-\d+\s*$/, '').trim();
      const value = target instanceof HTMLSelectElement ? target.selectedOptions[0]?.textContent?.trim() : target.value;
      const sectionId = productInfo.dataset.section;

      if (!sectionId) return;

      const state = {
        optionIndex,
        details: selectionDetails(optionName, String(value || '').trim()),
      };
      pendingSelections.set(sectionId, state);

      if (optionIndex === 1) requestAnimationFrame(() => activateAccessoryMedia(productInfo, state.details));
    });

    const subscribeWhenReady = () => {
      if (
        typeof subscribe !== 'function' ||
        typeof PUB_SUB_EVENTS === 'undefined' ||
        !PUB_SUB_EVENTS.variantChange
      ) {
        window.setTimeout(subscribeWhenReady, 50);
        return;
      }

      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const state = pendingSelections.get(data.sectionId);
        if (!state || state.optionIndex !== 1) return;

        const selector = `product-info[data-section="${CSS.escape(data.sectionId)}"]`;
        const productInfo = document.querySelector(selector);
        requestAnimationFrame(() => activateAccessoryMedia(productInfo, state.details));
      });
    };

    subscribeWhenReady();
  })();

  } catch(e) { console.error(e); }
})();
})();
